import React, {Fragment} from 'react';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';

// Images 
import INR from "../../../../assets/INR.png";

const borderColor = '#404040'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#404040',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
    },
    description: {
        width: '55%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    qty: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    rate: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    amount: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
        // width: "150px"
    },
    INR: {
        height: "8px",
        marginLeft: 6,
    }
  });


const InvoiceTableRow = ({items}) => {
    // console.log("Lohith:Payment:InvoiceTableRow : items",items);
    const rows = items.map( item => 
        <View style={styles.row} key={item.name}>
            <Text style={styles.description}>{item.name == 'Hi' ? 'hi™' : item.name == 'HiLite' ? 'hilite™' : 'hiRender™'} - {item.plan} plan</Text>
            <Text style={styles.qty}>{item.month}</Text>
            <Image style={styles.INR} src={INR} />
            <Text style={styles.rate}>{item.amount}</Text>
            <Image style={styles.INR} src={INR} />
            <Text style={styles.amount}>{(item.total).toFixed(2)}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
export default InvoiceTableRow